export enum ExperienceLevelEnum {
  NoExperience = "no_experience",
  SomeExperience = "some_experience",
  Expert = "expert",
}
